<template>
  <div class="popup__content-form">
    <form @submit.prevent="debounce(validate)" class="form">
      <div class="form__inputs">
        <div class="default-input">
          <input @input="this.reset" v-model="name" class="default-input__input" type="text" v-bind:class="{'default-input__input--error':errors.some(er => er.code === 4)}" placeholder="ФИО*">
          <span v-if="errors.some(er => er.code === 4)" class="default-input__error"></span>
        </div>
        <div class="default-input">
          <input @input="this.reset" v-model="email" class="default-input__input" type="text" v-bind:class="{'default-input__input--error':errors.some(er => er.code === 5)}" placeholder="E-mail*">
          <span v-if="errors.some(er => er.code === 5)" class="default-input__error"></span>
        </div>
        <div class="default-input">
          <input @input="this.reset" @paste.prevent="removeFirstDigit" v-model="phone" v-bind:class="{'default-input__input--error':errors.some(er => er.code === 1)}" class="default-input__input" type="text" data-mask-phone placeholder="Телефон*">
          <span v-if="errors.some(er => er.code === 1)" class="default-input__error"></span>
        </div>
        <div class="default-input">
          <input @input="this.reset" v-model="password" class="default-input__input" v-bind:class="{'default-input__input--error':errors.some(er => er.code === 2)}" type="password" placeholder="Пароль*">
          <span v-if="errors.some(er => er.code === 2)" class="default-input__error"></span>
        </div>
        <div class="default-input">
          <input @input="this.reset" v-model="confirm" class="default-input__input" v-bind:class="{'default-input__input--error':errors.some(er => er.code === 3)}" type="password" placeholder="Повторите пароль*">
          <span v-if="errors.some(er => er.code === 3)" class="default-input__error"></span>
        </div>
        <div style="display: none">
          <vue-recaptcha ref="recaptcha" size="invisible" :sitekey="this.site_key" @verify="sendData" @expired="onCaptchaExpired"/>
        </div>
      </div>
      <div class="form__submit">
        <input class="form__submit-btn btn" value="Зарегистрироваться" type="submit"/>
        <div class="form__submit-text">Нажимая кнопку, Вы даете информированное согласие на
          <a target="_blanc" :href="modulePolicy.file_src">обработку своих персональных данных</a>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import recaptcha  from "@/components/mixins/recaptcha";
import errors     from "@/components/mixins/errors";
import tools      from "@/components/mixins/tools";
import {mapState} from "vuex";
import { reachGoal as ymReachGoal } from "@/modules/metrika";

export default {
  name   : "RegistrationForm",
  mixins : [recaptcha, errors, tools],
  data()
  {
    return {
      name     : "",
      email    : "",
      phone    : "",
      password : "",
      confirm  : ""
    };
  },
  computed : {
    ...mapState([
      "modulePolicy"
    ])
  },
  methods  : {
    sendData( recaptchaToken )
    {
      this.reset();
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("phone", this.phone);
      formData.append("password", this.password);
      formData.append("confirm", this.confirm);
      formData.append("token", recaptchaToken);
      fetch("/api/user/registration/", {
        method : "POST",
        body   : formData
      })
      .then(response => response.json())
      .then(async resp =>
      {
        if(resp.success !== true)
        {
          let errs = JSON.parse(resp.message);
          this.parse(errs);
        }
        else
        {
          ymReachGoal('registration');
          this.clear();
          window.toast.success("Спасибо за регистрацию!", "Ссылка для подтверждения регистрации успешно выслана на вашу почту.");
          setTimeout(function()
          {
            location.href = "/catalog/";
          }, 5000);
        }
      });
    },
    clear()
    {
      this.name     = "";
      this.email    = "";
      this.phone    = "";
      this.password = "";
      this.confirm  = "";
    }
  },
};
</script>

<style scoped>

</style>
